module.exports = __webpack_public_path__ + "img/right-1.2cc6f5b3.png";